import * as React from "react";
import FieldActions from "./actions/FieldActions";
import InteractiveContext from "./contexts/InteractiveContext";
const Field = ({ children = null, disabled = false, menuContainer = document.body, name, type }) => /* @__PURE__ */ React.createElement(InteractiveContext.Consumer, null, (interactive) => interactive ? /* @__PURE__ */ React.createElement(
  FieldActions,
  {
    element: children || name,
    disabled: !interactive || disabled,
    menuContainer,
    name,
    type
  },
  name,
  " = ",
  type.type
) : /* @__PURE__ */ React.createElement("span", null, children));
export default Field;
